const CONECCTIONSVIEW = {  
  company: "Compañía",
  typeConnection: "Tipo de conexión",
  motorConnection: "Motor de conexión",
  nameConnection: "Nombre de la conexion:",
  user: "Usuario",
  password: "Contraseña",
  dataBase: "Base de datos",
  host: "Host",
  idProject: "Id del proyecto",
  idProjectGCP: "ID del Proyecto (GCP)",
  nameInstance: "Nombre de la Instancia",
  examplePlaceHolder: "Ejemplo: instancia:zona",
  update: "Actualizar",
  create: "Crear",
  restore: "Restablecer",
  cancel: "Cancelar",
  managerConnection: "Gestor de Conexiones",
  selectCompany: "Selecciona una Compañia para continuar",
  selectTypeConnection: "Selecciona un tipo de conexión",
  selectMotorConnection: "Selecciona un motor de conexion para continuar",
  enterNameConnecction: "Ingresa el nombre de la conexion",
  manageKeys: "Gestor de Claves",
  validateNameConnection: "Ingrese un nombre de conexion valido (al menos 3 caracteres)",
  validateNameUser: "Ingrese un nombre de usuario (al menos 3 caracteres)",
  validateKeys: "Ingrese una contraseña valida (al menos 6 caracteres)",
  validateNameDB: "Ingrese un nombre de base de datos valida (al menos 3 caracteres)",
  host: "Host",
  enterIpHost: "Ingrese la IP del host.",
  validateIpHost: "Ingrese una IP válida para el host.",
  pahtConnection: "Ruta de conexión",
  selectFormConecction: "Seleccione la forma de conexón.",
  nameProject: "Nombre del proyecto",
  validateIdProyect: "Ingrese el ID del proyecto (al menos 6 caracteres)",
  nameInstance: "Nombre de instancia",
  validateInstane: "Ingrese un nombre de instancia válido (al menos 3 caracteres)",
  errorSaveConnection: "Ocurrio un error, al guardar la Conexion({error})",
  updateConnection: "Conexion actualizada con exito!",
  emptyCompanies: "No hay compañias registradas.",
  listCompanies: "Lista de compañias",
  _updateConnection: "Actualizando Conexión",
  _newConnection: "Nueva Conexión",

  name: "Nombre",
  company: "Compañía",
  type: "Tipo",
  actions: "Acciones",
  emptyConnections: "No hay conexiones registrados.",
  listConnections: "Lista de Conexiones",
  deleteConnection: "Eliminar Conexión: {data}",
  advertencie: "Ésta opción no se puede deshacer, está seguro?",
  accept: "Aceptar",
  titleDeleteConnection: "Eliminar Conexión",
  errorToDelecteConnection: "Ocurrio un error, al eliminar la Conexión",
  actionDisabled: "Acción no disponible de momento"
};

export default { CONECCTIONSVIEW };
